
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 7.005a5.442 5.442 0 01-1.57.767 2.239 2.239 0 00-2.489-.624 2.24 2.24 0 00-1.441 2.13v.5A5.316 5.316 0 017 7.508s-2 4.514 2.5 6.52A5.807 5.807 0 016 15.03c4.5 2.508 10 0 10-5.768 0-.14-.014-.279-.04-.416.51-.505.87-1.142 1.04-1.841v0z","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10z","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    